import React from 'react'
import { Link } from 'gatsby'
import { OutboundLink } from 'gatsby-plugin-google-analytics'
import StyledButton from './CtaButton.styles'

const CtaButton = ({
  inverse,
  children,
  slug,
  outLink,
  secondary,
  size,
  bSize,
  bgColor,
  textColor,
  minW,
  submit,
  square,
  action,
}) => {
  if (action) {
    return (
      <div className="cta">
        <StyledButton
          onClick={action}
          bgColor={bgColor}
          secondary={secondary}
          inverse={inverse}
          size={size}
          bSize={bSize}
          minW={minW}
          square={square}
          textColor={textColor}
        >
          {children}
        </StyledButton>
      </div>
    )
  }
  if (submit) {
    return (
      <div className="cta">
        <StyledButton
          type="submit"
          bgColor={bgColor}
          secondary={secondary}
          inverse={inverse}
          size={size}
          minW={minW}
          square={square}
          textColor={textColor}
        >
          {children}
        </StyledButton>
      </div>
    )
  }
  if (outLink) {
    return (
      <div className="cta">
        <OutboundLink href={outLink || 'https://promazo.com/'}>
          <StyledButton
            bgColor={bgColor}
            secondary={secondary}
            inverse={inverse}
            size={size}
            minW={minW}
            square={square}
            textColor={textColor}
          >
            {children}
          </StyledButton>
        </OutboundLink>
      </div>
    )
  }
  return (
    <div className="cta">
      <Link to={slug || '/'}>
        <StyledButton
          bgColor={bgColor}
          secondary={secondary}
          inverse={inverse}
          size={size}
          minW={minW}
          square={square}
          textColor={textColor}
        >
          {children}
        </StyledButton>
      </Link>
    </div>
  )
}

export default CtaButton
